import React from 'react'
import BaseYouMayAlsoLikeTile from './BaseYouMayAlsoLikeTile'
import ProductTypeLabel from 'components/Luxkit/Label/ProductTypeLabel'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import useBedbankRates from 'hooks/useBedbankRates'
import { EmptyObject } from 'lib/object/objectUtils'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'

interface Props {
  offer: App.BedbankOfferWithRate;
  filters?: App.OfferListFilters;
}

function BedbankYouMayAlsoLikeTile({ offer, filters = EmptyObject }: Props) {
  const [rates] = useBedbankRates(offer.id, filters.rooms, filters.checkIn, filters.checkOut)
  const rate = rates[0]

  return (
    <BaseYouMayAlsoLikeTile
      image={offer.image}
      location={[offer.property.address.city, offer.property.address.stateProvinceName].filter(t => t).join(', ')}
      title={offer.name}
      subtitle={offer.amenities}
      walledGarden={offer.walledGarden}
    >
      <BaseYouMayAlsoLikeTile.ImageBadges>
        <ProductTypeLabel productType={offer.productType} />
      </BaseYouMayAlsoLikeTile.ImageBadges>
      <BaseYouMayAlsoLikeTile.PriceDetails>
        {rate && (
          <>
            <PriceRowPriceCaption>{rate.nights} nights from</PriceRowPriceCaption>
            <PriceRowPrice
              size="M"
              price={Math.ceil(rate.totals.inclusive)}
              saleUnit="total"
              taxesAndFees={rate.totals.taxesAndFees}
            />
            <BodyText variant="small" colour="neutral-two">
              Incl. taxes &amp; fees
            </BodyText>
          </>
        )}
        {!rate && (
          <TextLink><BodyText variant="medium" weight="semi-bold">Select dates to view prices</BodyText></TextLink>
        )}
      </BaseYouMayAlsoLikeTile.PriceDetails>
    </BaseYouMayAlsoLikeTile>
  )
}

export default BedbankYouMayAlsoLikeTile
